import { Injectable } from '@angular/core';
import { gql } from '@apollo/client';
import { Query } from 'apollo-angular';

import { TintedColor } from '../models/tinted-color.model';

export interface TtintedColorsQueryResponse {
  colors: TintedColor[];
}

export interface TintedColorsQueryVariables {
  productGroupId: string;
  searchString: string;
  languageCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class TintedColorsQuery extends Query<TtintedColorsQueryResponse, TintedColorsQueryVariables> {
  override document = gql`
    query colors($productGroupId: String, $searchString: NonEmptyString!, $languageCode: NonEmptyString!) {
      colors(
        languageCode: $languageCode
        colorSearch: { searchString: $searchString, productGroupId: $productGroupId }
      ) {
        colorId
        code
        hex
        name
        paletteCode
        paletteName
      }
    }
  `;
}
